import FieldDescription from "../tools/FieldDescription";
import PostalCodeField from "./PostalCodeField";
import { civilities } from "../../static/types/commonTypes/legalEntityType"
import useValidation from "../../hooks/useValidation";
import { useEffect, useState } from "react";
import { LegalEntityType, LegalEntityTypeOfficiant } from "../../static/types/commonTypes/legalEntityType";
import OfficiantValidationSchema from "../../utils/validation/officiantValidationSchema";
import { DateType } from "../../static/types/commonTypes/dateType";
import { format, parse, isValid } from "date-fns";
import DateComponent from "./DateComponent";
import useAppContext from "../../hooks/useAppContext";
import { AppContextType } from "../../context/AppContext";
import IndividualPerson from "./IndividualPerson";
import { IndividualPersonType } from "../../static/types/commonTypes/individualType";
import legalEntityValidationSchema from "../../utils/validation/legalEntityValidationSchema";

type DecedeProps = {
    checkedDecede: boolean,
    decedes: LegalEntityType,
    changeDecede: (data: Partial<LegalEntityType>) => void,
    onValidationChangeDecedes: (isValid: boolean) => void
}

export default function Decedes({
    checkedDecede,
    decedes,
    changeDecede,
    onValidationChangeDecedes,
}: DecedeProps) {

    const {
        datedeces, setdatedeces,
        datecheckedDeces, setdatecheckedDeces,
        dateValidityDeces, setDateValidityDeces,

        individual, setIndividual,
        individualValidity, setIndividualValidity,
        individualChecked, setIndividualChecked,
    } = useAppContext() as AppContextType

    const updateDate = (data: Partial<DateType>) => setdatedeces({ ...datedeces, ...data })
    const [decesEtranger, setDecesEtranger] = useState(false);



    const { errors, isValid: isDataValid } = useValidation(decedes, legalEntityValidationSchema);

    useEffect(() => {
        onValidationChangeDecedes(isDataValid)
    }, [isDataValid, onValidationChangeDecedes])

    return (

        <div className="mb-3 row">
            <IndividualPerson
                changeIndividual={(partialIndividual: Partial<IndividualPersonType>) => setIndividual({ ...individual, ...partialIndividual })}
                checked={individualChecked}
                individual={individual}
                onValidationChange={(isValid: boolean) => setIndividualValidity(isValid)}
                draftFieldName = "individual"
            />
            <DateComponent
                checked={datecheckedDeces}
                changeDate={updateDate}
                date={datedeces}
                draftFieldName = "datedeces"
                dateLabel="Date du décès"
                onValidationChange={(isValid: boolean) => setDateValidityDeces(isValid)}
                required={true}
                id="datedeces"
            />
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "16px" }}>
                    Décès à l'étranger
                    <input
                        type="checkbox"
                        style={{ width: "18px", height: "18px", marginLeft: "5px" }}
                        checked={decesEtranger}
                        onChange={() => setDecesEtranger(!decesEtranger)}
                    />
                </label>
            </div>

            <div className="col-sm-12">
                <PostalCodeField
                    checked={checkedDecede}
                    errors={errors}
                    postalCode={decedes.postalCode || ""}
                    onChange={(partialData: Partial<LegalEntityType>) =>
                        changeDecede({ ...decedes, ...partialData })
                    }
                />
            </div>

            <div className="row mb-3">
                <label htmlFor="city" className="col-sm-2 col-form-label">
                    Ville <strong className="text-danger">*</strong>
                </label>
                <div className="col-sm-4">
                    <select
                        id="city"
                        className={`form-select ${checkedDecede && errors.city ? "is-invalid" : ""}`}
                        value={decedes.city || ""}
                        onChange={(event) => changeDecede({ city: event.target.value })}
                    >
                        {decedes.cities?.map((city, idx) => (
                            <option key={idx} value={city}>
                                {city}
                            </option>
                        ))}
                    </select>
                    {checkedDecede && errors.city && (
                        <div className="invalid-feedback">{errors.city}</div>
                    )}
                    <FieldDescription description="Sélectionnez la ville associée à votre code postal" />
                </div>
            </div>

        </div>
    )
}